import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { BrowserRouter } from 'react-router-dom'
import zh_CN from '@douyinfe/semi-ui/lib/es/locale/source/zh_CN'
import en_GB from '@douyinfe/semi-ui/lib/es/locale/source/en_GB'


import RenderRouter from '../router'
import { localeConfig } from '../locales';
import { LocaleProvider, Spin, Toast } from '@douyinfe/semi-ui';
import { IntlProvider } from 'react-intl'
import { ADMIN_MENU_CONFIG, USER_MENU_CONFIG } from "../pages/menus/config";
import { getLocalStorage, setLocalStorage } from "../utils/storage";
import request from "../utils/request";


export const ZxContext = createContext();
export function useZxContext() {
  return useContext(ZxContext);
}

export default function AppContext({ children }) {
  const [loading, setLoading] = useState(true);
  const [isLogin, setLogin] = useState(false);
  const [userinfo, setUserinfo] = useState({});
  const [locale, setLocale] = useState('zh_CN')
  const [tags, setTags] = useState([])
  const [activeTagId, setActiveTagId] = useState('')
  const [menuList, setMenuList] = useState([])


  const getLocale = useMemo(() => {
    if (locale === 'en_GB') {
      return en_GB
    } else if (locale === 'zh_CN') {
      return zh_CN
    }
  }, [locale])

  useEffect(() => {
    const appInit = async () => {
      let locale = getLocalStorage('zx_config_locale')
      if (!locale) {
        locale = 'zh_CN'
      }
      setLocale(locale)

      let userinfo = getLocalStorage('zx_userinfo')
      if (userinfo) {
        userinfo = JSON.parse(userinfo)
        if (Object.keys(userinfo).length > 0) {
          const response = await request({
            url: '/api/auth/check_expired', method: 'get', headers: {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + userinfo.token,
            },
          })
          if (response.msg === false) {
            Toast.error('登录已过期')
            setTimeout(()=>window.location.reload(), 1500)
            return
          }

          setUserinfo(userinfo)
          setLogin(true)
        }
      }

      /** 应用启动 */
      setLoading(false);
      console.log("AppContext.useEffect init finished");
    };

    appInit();
  }, []);

  useEffect(() => {
    if (userinfo.role === 0) {
      setMenuList(ADMIN_MENU_CONFIG)
    } else if (userinfo.role === 1) {
      setMenuList(USER_MENU_CONFIG)
    }

    setLocalStorage('zx_userinfo', JSON.stringify(userinfo))



  }, [userinfo])

  const setActiveTag = tag => setActiveTagId(tag)
  const addTag = tagItem => {
    const isExist = tags.filter((e) => e.id === tagItem.id)
    if (isExist.length === 0) {
      setTags([...tags, tagItem])
      setActiveTag(tagItem.id)
    } else {
      setActiveTag(tagItem.id)
    }
  }
  const removeTag = targetId => {
    const tagList = tags.filter((tag) => tag.id !== targetId)
    if (tagList.length > 0) {
      if (activeTagId === targetId) {
        const index = tags.findIndex((e) => e.id == activeTagId)
        setActiveTagId(tags[index - 1].id)
        setTags(tagList)
      } else {
        setTags(tagList)
      }
    }
  }
  const changeLocale = val => {
    if (val === 'zh_CN') setLocale('zh_CN')
    else setLocale('en_GB')
  }

  const zxContext = {
    isLogin,
    setLogin,
    userinfo,
    setUserinfo,
    locale,
    setLocale,
    tags,
    activeTagId,
    setActiveTag,
    addTag,
    removeTag,
    changeLocale,
    menuList,
    setTags,
  }

  return (
    <ZxContext.Provider value={zxContext}>
      {!loading ? (
        <LocaleProvider locale={getLocale}>
          <IntlProvider locale={locale.split('_')[0]} messages={localeConfig[locale]}>
            <BrowserRouter>
              <RenderRouter />
            </BrowserRouter>
          </IntlProvider>
        </LocaleProvider>
      ) : <Spin size='large' style={{ position: 'absolute', left: '50%', transform: 'translate3d(-50%)' }} />}
    </ZxContext.Provider>
  );
}
